import { render, staticRenderFns } from "./CloseChapters.vue?vue&type=template&id=7cf46ce4&"
import script from "./CloseChapters.vue?vue&type=script&lang=js&"
export * from "./CloseChapters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports